/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');
var Ladda = require('ladda');
var moment = require('moment');

var EmptyView = require('common/views/EmptyView');
var FileUploadView = require('common/views/FileUploadView');
var SpinnerView = require('common/views/SpinnerView');
var BreadcrumbView = require('common/views/BreadcrumbView');
var modelGet = require('common/util/modelGet');
var makeUploadCollection = require('common/util/makeUploadCollection');
var GenerateAdHocDocument = require('../../common/services/GenerateAdHocDocument');
var LicenseHeaderBarView = require('../../common/views/LicenseHeaderBarView');
var GetLicenseTypeDocumentTemplateByLicenseTypeAndDocIdentifier = require('../../common/services/GetLicenseTypeDocumentTemplateByLicenseTypeAndDocIdentifier');

var NonDepLicenseDocGen15DayAdminActionView = require('./NonDepLicenseDocGen15DayAdminActionView');
var NonDepLicenseDocGenIRTRView = require('./NonDepLicenseDocGenIRTRView');
var NonDepLicenseDocGenRTRView = require('./NonDepLicenseDocGenRTRView');
var NonDepLicenseDocGenTentSaleView = require('./NonDepLicenseDocGenTentSaleView');

require('../styles/NonDepLicenseDocGenView.css');
var tmplNonDepLicenseDocGenView = require('../templates/NonDepLicenseDocGenView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepLicenseDocGenView,

  className: 'non-dep-license-doc-gen-view container-fluid',

  ui: {
    headerBarContainer: '.header-bar-container',
    breadcrumb: '.breadcrumb-container',
    parametersContainer: '.parameters-container',
    documentTemplateIdentifier: '.document-template-identifier',
    submit: '.submit',
    docGenForm: '.doc-gen-form',
    documentContainer: '.document-container',
    downloadContainer: '.download-container'
  },

  regions: {
    headerBarContainer: '@ui.headerBarContainer',
    breadcrumb: '@ui.breadcrumb',
    parametersContainer: '@ui.parametersContainer',
    documentContainer: '@ui.documentContainer',
    downloadContainer: '@ui.downloadContainer'
  },

  templateHelpers: function() {
    var licenseTypeId = this.model.get('licenseIdentifier').licenseTypeId;
    return {
      showRTR: !_.contains(['6', '33', '34'], licenseTypeId)
    };
  },

  events: {
    'change @ui.documentTemplateIdentifier': 'onChangeDocumentTemplate',
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var entityId = this.model.get('entityId');
    var entityName = modelGet(this.model, 'licenseIdentifier.entityName');
    var licenseNumber = modelGet(this.model, 'licenseIdentifier.licenseNumber');
    var licenseType = modelGet(this.model, 'licenseIdentifier.licenseType');
    var licenseId = modelGet(this.model, 'licenseIdentifier.id');

    this.showChildView(
      'headerBarContainer',
      new LicenseHeaderBarView({
        model: new Backbone.Model(this.model.get('licenseIdentifier'))
      })
    );

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            text: 'Home',
            link: '#nondep/dashboard'
          },
          {
            text: entityName,
            link: '#nondep/entity/' + entityId + '/dashboard'
          },
          {
            text: 'License #' + licenseNumber + ' - ' + licenseType,
            link: '#nondep/entity/' + entityId + '/license/' + licenseId
          },
          {
            text: 'Generate Document'
          }
        ]
      })
    );
  },

  onChangeDocumentTemplate: function() {
    var templateIdentifier = this.ui.documentTemplateIdentifier.val();
    if (templateIdentifier === 'ND_15_DAY_ADMINISTRATIVE_ACTION_TEMPLATE') {
      this.showChildView('parametersContainer', new NonDepLicenseDocGen15DayAdminActionView());
    } else if (templateIdentifier === 'IRTR') {
      this.showChildView('parametersContainer', new NonDepLicenseDocGenIRTRView());
    } else if (templateIdentifier === 'RTR') {
      this.showChildView('parametersContainer', new NonDepLicenseDocGenRTRView());
    } else if (templateIdentifier === 'ND_TENT_SALE_TEMPLATE') {
      this.showChildView('parametersContainer', new NonDepLicenseDocGenTentSaleView());
    } else if (
      templateIdentifier === 'ND_MORTGAGE_ORIGINATOR_INACTIVE_TEMPLATE' ||
      templateIdentifier === 'ND_15_DAY_UNLICENSED_LOCATION_SPONSORSHIP_TEMPLATE' ||
      templateIdentifier === 'ND_CERTIFICATE_TEMPLATE' ||
      templateIdentifier === ''
    ) {
      this.showChildView('parametersContainer', new EmptyView());
    }
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    var licenseTypeId = modelGet(this.model, 'licenseIdentifier.licenseTypeId');

    this.validate().done(function() {
      var formData = self.getFormData();
      formData.licenseId = modelGet(self.model, 'licenseIdentifier.id');

      var l = Ladda.create(self.ui.submit[0]);
      l.start();

      // Show label for downloaded doc
      self.ui.downloadContainer.show();

      // Show spinner where document will appear
      self.showChildView(
        'documentContainer',
        new SpinnerView({
          spinner: {
            scale: '0.5'
          }
        })
      );

      // Generate file based on document template
      GetLicenseTypeDocumentTemplateByLicenseTypeAndDocIdentifier({
        licenseTypeId: licenseTypeId,
        documentTypeIdentifier: formData.documentTemplateIdentifier
      })
        .then(function(data) {
          formData.documentTemplateName = data.templateName;
          return GenerateAdHocDocument(formData);
        })
        .then(function(file) {
          self.showChildView(
            'documentContainer',
            new FileUploadView({
              isReadOnly: true,
              collection: makeUploadCollection(file)
            })
          );
          l.stop();
        })
        .fail(function() {
          l.stop();
          self.showChildView('documentContainer', new EmptyView());
        });
    });
  },

  validate: function() {
    return this.ui.docGenForm.parsley().whenValidate();
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);

    if (formData.tentSaleDate) {
      formData.tentSaleDate = moment(formData.tentSaleDate, 'MM/DD/YYYY').format('YYYY-MM-DD');
    }

    if (formData.advisoryLetterDate) {
      formData.advisoryLetterDate = moment(formData.advisoryLetterDate, 'MM/DD/YYYY').format('YYYY-MM-DD');
    }
    return formData;
  }
});
